import { render, staticRenderFns } from "./FooterM.vue?vue&type=template&id=767f77c9&scoped=true&"
import script from "./FooterM.vue?vue&type=script&lang=js&"
export * from "./FooterM.vue?vue&type=script&lang=js&"
import style0 from "./FooterM.vue?vue&type=style&index=0&id=767f77c9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767f77c9",
  null
  
)

export default component.exports